export const answersList = [
  {
    name: "Strongly Dislike",
    value: 1,
  },
  {
    name: "Dislike",
    value: 2,
  },
  {
    name: "Unsure",
    value: 3,
  },
  {
    name: "Like",
    value: 4,
  },
  {
    name: "Strongly Like",
    value: 5,
  },
];

export const questionsList = [
  {
    index: 1,
    area: "Realistic",
    text: "Build custom furniture",
  },
  {
    index: 2,
    area: "Realistic",
    text: "Lay brick or tile",
  },
  {
    index: 3,
    area: "Investigative",
    text: "Develop a new medicine",
  },
  {
    index: 4,
    area: "Investigative",
    text: "Study ways to reduce water pollution",
  },
  {
    index: 5,
    area: "Artistic",
    text: "Write books or plays",
  },
  {
    index: 6,
    area: "Artistic",
    text: "Play a musical instrument or be a music producer",
  },
  {
    index: 7,
    area: "Social",
    text: "Instruct individuals in wellness and fitness",
  },
  {
    index: 8,
    area: "Social",
    text: "Provide mental health counselling or therapy",
  },
  {
    index: 9,
    area: "Enterprising",
    text: "Buy and sell stocks and bonds",
  },
  {
    index: 10,
    area: "Enterprising",
    text: "Use social media to influence shoppers or brand partnerships",
  },
  {
    index: 11,
    area: "Conventional",
    text: "Develop data analytics algorithms",
  },
  {
    index: 12,
    area: "Conventional",
    text: "Proofread websites, reports, and brochures",
  },
  {
    index: 13,
    area: "Realistic",
    text: "Repair household appliances",
  },
  {
    index: 14,
    area: "Realistic",
    text: "Raise fish in a fish hatchery",
  },
  {
    index: 15,
    area: "Investigative",
    text: "Build artificial intelligence algorithms",
  },
  {
    index: 16,
    area: "Investigative",
    text: "Study the movement of planets",
  },
  {
    index: 17,
    area: "Artistic",
    text: "Compose or arrange music",
  },
  {
    index: 18,
    area: "Artistic",
    text: "Create digital illustrations or graphic designs for websites or ads",
  },
  {
    index: 19,
    area: "Social",
    text: "Give career guidance to people",
  },
  {
    index: 20,
    area: "Social",
    text: "Perform rehabilitation therapy",
  },
  {
    index: 21,
    area: "Enterprising",
    text: "Operate a beauty salon or barber shop",
  },
  {
    index: 22,
    area: "Enterprising",
    text: "Manage a team within a large company",
  },
  {
    index: 23,
    area: "Conventional",
    text: "Operate and maintain a company’s internetal IT",
  },
  {
    index: 24,
    area: "Conventional",
    text: "Analyze trends in data to improve operational efficiencies",
  },
  {
    index: 25,
    area: "Realistic",
    text: "Assemble electronic parts",
  },
  {
    index: 26,
    area: "Realistic",
    text: "Drive a delivery truck",
  },
  {
    index: 27,
    area: "Investigative",
    text: "Examine blood samples using a microscope",
  },
  {
    index: 28,
    area: "Investigative",
    text: "Investigate the cause of a fire",
  },
  {
    index: 29,
    area: "Artistic",
    text: "Create special effects for movies",
  },
  {
    index: 30,
    area: "Artistic",
    text: "Design or paint sets for live performances",
  },
  {
    index: 31,
    area: "Social",
    text: "Do volunteer work at a non-profit organization",
  },
  {
    index: 32,
    area: "Social",
    text: "Teach children how to play sports",
  },
  {
    index: 33,
    area: "Enterprising",
    text: "Start your own business",
  },
  {
    index: 34,
    area: "Enterprising",
    text: "Negotiate business contracts",
  },
  {
    index: 35,
    area: "Conventional",
    text: "Create and manage budgets",
  },
  {
    index: 36,
    area: "Conventional",
    text: "Calculate the wages of employees",
  },
  {
    id: 397,
    index: 37,
    area: "Realistic",
    text: "Test the quality of parts before shipment",
  },
  {
    index: 38,
    area: "Realistic",
    text: "Repair and install security systems and locks",
  },
  {
    index: 39,
    area: "Investigative",
    text: "Develop a way to better predict the weather",
  },
  {
    index: 40,
    area: "Investigative",
    text: "Work in a biology lab",
  },
  {
    index: 41,
    area: "Artistic",
    text: "Write scripts for movies or television shows",
  },
  {
    index: 42,
    area: "Artistic",
    text: "Perform dance routines",
  },
  {
    index: 43,
    area: "Social",
    text: "Teach sign language to people who are deaf or hard of hearing",
  },
  {
    index: 44,
    area: "Social",
    text: "Help conduct a group therapy session",
  },
  {
    index: 45,
    area: "Enterprising",
    text: "Represent a client in a lawsuit",
  },
  {
    index: 46,
    area: "Enterprising",
    text: "Market a new line of clothing",
  },
  {
    index: 47,
    area: "Conventional",
    text: "Optimize inventory systems using tech-driven solutions",
  },
  {
    index: 48,
    area: "Conventional",
    text: "Record rent payments",
  },
  {
    index: 49,
    area: "Realistic",
    text: "Operate advanced manufacturing machines or 3D printers",
  },
  {
    index: 50,
    area: "Realistic",
    text: "Put out forest fires",
  },
  {
    index: 51,
    area: "Investigative",
    text: "Invent a replacement for sugar",
  },
  {
    index: 52,
    area: "Investigative",
    text: "Do laboratory tests to identify diseases",
  },
  {
    index: 53,
    area: "Artistic",
    text: "Sing in a band",
  },
  {
    index: 54,
    area: "Artistic",
    text: "Film, produce, or edit movies",
  },
  {
    index: 55,
    area: "Social",
    text: "Take care of children at a day-care center",
  },
  {
    index: 56,
    area: "Social",
    text: "Teach a high-school class",
  },
  {
    index: 57,
    area: "Enterprising",
    text: "Lead sales teams to promote cutting-edge technology solutions",
  },
  {
    index: 58,
    area: "Enterprising",
    text: "Manage a retail store",
  },
  {
    index: 59,
    area: "Conventional",
    text: "Keep inventory records",
  },
  {
    index: 60,
    area: "Conventional",
    text: "Manage office operations and supplies",
  },
];
